// Pure formulas shared by the browser and Node tests. All monetary values are ARS.
function $e403fb458c8fd10f$var$finite(value, name, min, max = 1e12) {
    if (!Number.isFinite(value) || value < min || value > max) throw new RangeError(`${name}: ingres\xe1 un n\xfamero entre ${min} y ${max}.`);
    return value;
}
function $e403fb458c8fd10f$var$odds(value) {
    if (!Number.isFinite(value) || value <= 1 || value > 1000000) throw new RangeError('Las cuotas deben ser mayores que 1 y no superar 1.000.000.');
    return value;
}
function $e403fb458c8fd10f$export$44c8c719216d9bfc(value) {
    const normalized = String(value).trim().replace(/[ \u00a0\u202f]/g, '').replace(',', '.');
    if (!/^\d+(?:\.\d+)?$/.test(normalized)) throw new RangeError("Complet\xe1 todos los campos con n\xfameros. Us\xe1 coma o punto como separador decimal.");
    const number = Number(normalized);
    if (!Number.isFinite(number)) throw new RangeError("Ingres\xe1 un valor num\xe9rico finito.");
    return number;
}
function $e403fb458c8fd10f$export$4bf251cf851815a5(stake, coefficient) {
    $e403fb458c8fd10f$var$finite(stake, 'Monto', 0);
    $e403fb458c8fd10f$var$odds(coefficient);
    return {
        payout: stake * coefficient,
        profit: stake * (coefficient - 1),
        stake: stake,
        loss: stake,
        implied: 100 / coefficient
    };
}
function $e403fb458c8fd10f$export$5dff44615331be3b(bankroll, coefficient, probability, fraction = 0.25) {
    $e403fb458c8fd10f$var$finite(bankroll, 'Bankroll', 0);
    $e403fb458c8fd10f$var$odds(coefficient);
    $e403fb458c8fd10f$var$finite(probability, 'Probabilidad (%)', 0, 100);
    if (![
        0.25,
        0.5,
        1
    ].includes(fraction)) throw new RangeError("Eleg\xed cuarto Kelly, medio Kelly o Kelly completo.");
    const fullPercent = Math.max(0, (probability / 100 * coefficient - 1) / (coefficient - 1));
    const full = bankroll * fullPercent;
    return {
        amount: full * fraction,
        percent: fullPercent * fraction * 100,
        full: full,
        half: full / 2,
        quarter: full / 4,
        hasEdge: fullPercent > 0
    };
}
function $e403fb458c8fd10f$export$3be60159d46c658f(home, draw, away) {
    const q = [
        home,
        draw,
        away
    ].map((value)=>1 / $e403fb458c8fd10f$var$odds(value));
    const total = q.reduce((sum, value)=>sum + value, 0);
    return {
        oneX: total / (q[0] + q[1]),
        xTwo: total / (q[1] + q[2]),
        oneTwo: total / (q[0] + q[2]),
        sum: total * 100,
        overround: (total - 1) * 100
    };
}


const $8bc7512de2a51525$var$contents = document.querySelector('[data-guide-toc]');
if ($8bc7512de2a51525$var$contents) {
    const mobile = matchMedia('(max-width: 760px)');
    const links = [
        ...$8bc7512de2a51525$var$contents.querySelectorAll('a[href^="#"]')
    ];
    const sections = links.map((link)=>document.getElementById(link.hash.slice(1)));
    const article = $8bc7512de2a51525$var$contents.closest('.guide-body').querySelector('.guide-content');
    const progress = document.querySelector('[data-guide-progress]');
    let current = -1;
    let frame = 0;
    const update = ()=>{
        frame = 0;
        const readingLine = mobile.matches ? 64 : 96;
        let active = 0;
        sections.forEach((section, index)=>{
            if (section && section.getBoundingClientRect().top <= readingLine) active = index;
        });
        // The calculator lives inside the bankroll section; return to that section
        // once its remaining prose scrolls into view.
        const activeSection = sections[active];
        if (activeSection && activeSection.getBoundingClientRect().bottom < readingLine) {
            const parentIndex = sections.findIndex((section)=>section && section !== activeSection && section.contains(activeSection));
            if (parentIndex !== -1) active = parentIndex;
        }
        const bounds = article.getBoundingClientRect();
        if (bounds.bottom <= window.innerHeight) active = links.length - 1;
        if (current !== active) {
            links.forEach((link, index)=>{
                if (index === active) link.setAttribute('aria-current', 'location');
                else link.removeAttribute('aria-current');
            });
            current = active;
        }
        const distance = Math.max(1, bounds.height - window.innerHeight + readingLine);
        const fraction = Math.max(0, Math.min(1, (readingLine - bounds.top) / distance));
        progress.style.transform = `scaleX(${fraction})`;
    };
    const scheduleUpdate = ()=>{
        if (!frame) frame = requestAnimationFrame(update);
    };
    links.forEach((link, index)=>{
        link.addEventListener('click', (event)=>{
            if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
            const section = sections[index];
            if (section) {
                event.preventDefault();
                if (location.hash !== link.hash) history.pushState(null, '', link.hash);
                section.tabIndex = -1;
                section.focus({
                    preventScroll: true
                });
                section.scrollIntoView({
                    block: 'start',
                    behavior: 'auto'
                });
            }
            scheduleUpdate();
        });
    });
    mobile.addEventListener('change', scheduleUpdate);
    window.addEventListener('popstate', ()=>{
        requestAnimationFrame(()=>{
            const index = links.findIndex((link)=>link.hash === location.hash);
            sections[index]?.scrollIntoView({
                block: 'start',
                behavior: 'auto'
            });
            scheduleUpdate();
        });
    });
    window.addEventListener('scroll', scheduleUpdate, {
        passive: true
    });
    window.addEventListener('resize', scheduleUpdate);
    window.addEventListener('load', scheduleUpdate);
    scheduleUpdate();
}


const $5f458853b35f86ca$var$button = document.querySelector('[data-back-to-top]');
if ($5f458853b35f86ca$var$button) {
    let frame = 0;
    const update = ()=>{
        frame = 0;
        $5f458853b35f86ca$var$button.hidden = window.scrollY < 400;
    };
    const scheduleUpdate = ()=>{
        if (!frame) frame = requestAnimationFrame(update);
    };
    $5f458853b35f86ca$var$button.addEventListener('click', ()=>{
        document.querySelector('.brand')?.focus({
            preventScroll: true
        });
        // CSS scroll-behavior also respects the reduced-motion preference.
        window.scrollTo({
            top: 0,
            behavior: 'auto'
        });
    });
    window.addEventListener('scroll', scheduleUpdate, {
        passive: true
    });
    window.addEventListener('pageshow', scheduleUpdate);
    update();
}


const $5cf3dad8561bc0d7$var$trigger = document.querySelector('[data-offers-open]');
const $5cf3dad8561bc0d7$var$dialog = document.getElementById('partner-offers');
if ($5cf3dad8561bc0d7$var$trigger && $5cf3dad8561bc0d7$var$dialog && typeof $5cf3dad8561bc0d7$var$dialog.showModal === 'function') {
    $5cf3dad8561bc0d7$var$trigger.hidden = false;
    $5cf3dad8561bc0d7$var$trigger.addEventListener('click', ()=>{
        if ($5cf3dad8561bc0d7$var$dialog.open) return;
        $5cf3dad8561bc0d7$var$dialog.showModal();
        document.documentElement.classList.add('offers-open');
        $5cf3dad8561bc0d7$var$trigger.setAttribute('aria-expanded', 'true');
    });
    $5cf3dad8561bc0d7$var$dialog.querySelectorAll('[data-offers-close]').forEach((button)=>{
        button.addEventListener('click', ()=>$5cf3dad8561bc0d7$var$dialog.close());
    });
    $5cf3dad8561bc0d7$var$dialog.addEventListener('keydown', (event)=>{
        if (event.key !== 'Tab') return;
        const controls = [
            ...$5cf3dad8561bc0d7$var$dialog.querySelectorAll('button:not([disabled]), a[href]')
        ];
        const first = controls[0];
        const last = controls[controls.length - 1];
        if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
        }
    });
    $5cf3dad8561bc0d7$var$dialog.addEventListener('click', (event)=>{
        if (event.target !== $5cf3dad8561bc0d7$var$dialog) return;
        const bounds = $5cf3dad8561bc0d7$var$dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) $5cf3dad8561bc0d7$var$dialog.close();
    });
    $5cf3dad8561bc0d7$var$dialog.addEventListener('close', ()=>{
        document.documentElement.classList.remove('offers-open');
        $5cf3dad8561bc0d7$var$trigger.setAttribute('aria-expanded', 'false');
        $5cf3dad8561bc0d7$var$trigger.focus({
            preventScroll: true
        });
    });
}


document.documentElement.classList.add('js-enabled');
const $0c5444ba1638078b$var$menuToggle = document.querySelector('.menu-toggle');
const $0c5444ba1638078b$var$nav = document.querySelector('.site-nav');
function $0c5444ba1638078b$var$closeMenu() {
    $0c5444ba1638078b$var$menuToggle?.setAttribute('aria-expanded', 'false');
    $0c5444ba1638078b$var$nav?.classList.remove('is-open');
}
$0c5444ba1638078b$var$menuToggle?.addEventListener('click', ()=>{
    const open = $0c5444ba1638078b$var$menuToggle.getAttribute('aria-expanded') !== 'true';
    $0c5444ba1638078b$var$menuToggle.setAttribute('aria-expanded', String(open));
    $0c5444ba1638078b$var$nav.classList.toggle('is-open', open);
});
document.addEventListener('keydown', (event)=>{
    if (event.key === 'Escape' && $0c5444ba1638078b$var$menuToggle?.getAttribute('aria-expanded') === 'true') {
        $0c5444ba1638078b$var$closeMenu();
        $0c5444ba1638078b$var$menuToggle.focus();
    }
});
document.addEventListener('click', (event)=>{
    if (!event.target.closest('.site-header')) $0c5444ba1638078b$var$closeMenu();
});
matchMedia('(min-width: 1001px)').addEventListener('change', $0c5444ba1638078b$var$closeMenu);
const $0c5444ba1638078b$var$directory = document.querySelector('[data-directory]');
if ($0c5444ba1638078b$var$directory) {
    let category = 'all';
    const search = $0c5444ba1638078b$var$directory.querySelector('[data-search]');
    const cards = [
        ...$0c5444ba1638078b$var$directory.querySelectorAll('[data-guide]')
    ];
    const buttons = [
        ...$0c5444ba1638078b$var$directory.querySelectorAll('[data-filter]')
    ];
    const update = ()=>{
        const query = search.value.toLocaleLowerCase('es-AR').trim();
        let count = 0;
        for (const card of cards){
            const visible = (category === 'all' || card.dataset.category === category) && card.textContent.toLocaleLowerCase('es-AR').includes(query);
            card.hidden = !visible;
            if (visible) count++;
        }
        $0c5444ba1638078b$var$directory.querySelector('[data-filter-status]').textContent = `Art\xedculos encontrados: ${count}`;
        $0c5444ba1638078b$var$directory.querySelector('[data-empty]').hidden = count > 0;
    };
    for (const button of buttons)button.addEventListener('click', ()=>{
        category = button.dataset.filter;
        buttons.forEach((item)=>item.setAttribute('aria-pressed', String(item === button)));
        update();
    });
    search.addEventListener('input', update);
    $0c5444ba1638078b$var$directory.querySelector('[data-clear-filters]').addEventListener('click', ()=>{
        search.value = '';
        buttons[0].click();
        search.focus();
    });
}
const $0c5444ba1638078b$var$calculator = document.querySelector('[data-calculator]');
if ($0c5444ba1638078b$var$calculator) {
    const tabs = [
        ...$0c5444ba1638078b$var$calculator.querySelectorAll('[data-tab]')
    ];
    const selectTab = (tab)=>{
        for (const item of tabs){
            const active = item === tab;
            item.setAttribute('aria-selected', String(active));
            item.tabIndex = active ? 0 : -1;
        }
        for (const panel of $0c5444ba1638078b$var$calculator.querySelectorAll('[data-panel]'))panel.hidden = panel.dataset.panel !== tab.dataset.tab;
    };
    for (const [index, tab] of tabs.entries()){
        tab.addEventListener('click', ()=>selectTab(tab));
        tab.addEventListener('keydown', (event)=>{
            let next;
            if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
            if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = tabs.length - 1;
            if (next !== undefined) {
                event.preventDefault();
                selectTab(tabs[next]);
                tabs[next].focus();
            }
        });
    }
    const format = (value, digits = 2)=>new Intl.NumberFormat('es-AR', {
            maximumFractionDigits: digits
        }).format(value);
    for (const form of $0c5444ba1638078b$var$calculator.querySelectorAll('[data-form]')){
        const panel = form.closest('[data-panel]');
        const result = panel.querySelector('.calculator-result');
        const error = form.querySelector('[data-error]');
        const run = (showError = true)=>{
            try {
                const values = Object.fromEntries([
                    ...new FormData(form)
                ].map(([key, value])=>[
                        key,
                        (0, $e403fb458c8fd10f$export$44c8c719216d9bfc)(value)
                    ]));
                let data;
                if (form.dataset.form === 'payout') data = (0, $e403fb458c8fd10f$export$4bf251cf851815a5)(values.stake, values.odds);
                if (form.dataset.form === 'kelly') {
                    data = (0, $e403fb458c8fd10f$export$5dff44615331be3b)(values.bankroll, values.odds, values.probability, values.fraction);
                    data.fractionLabel = ({
                        1: 'Kelly completo',
                        0.5: 'Medio Kelly',
                        0.25: 'Cuarto Kelly'
                    })[values.fraction];
                    data.explanation = data.hasEdge ? "Es un resultado del modelo, no un monto recomendado para apostar. Incluso Kelly fraccionado implica riesgo de p\xe9rdidas." : "Con la probabilidad ingresada, el modelo no identifica una ventaja. El monto te\xf3rico es 0 ARS.";
                }
                if (form.dataset.form === 'chance') data = (0, $e403fb458c8fd10f$export$3be60159d46c658f)(values.home, values.draw, values.away);
                for (const element of result.querySelectorAll('[data-value]')){
                    const key = element.dataset.value;
                    element.textContent = typeof data[key] === 'number' ? format(data[key], [
                        'oneX',
                        'xTwo',
                        'oneTwo'
                    ].includes(key) ? 3 : 2) : data[key];
                }
                error.hidden = true;
                error.textContent = '';
                result.classList.remove('result-invalid');
                result.querySelector('[data-status]').textContent = form.dataset.form === 'chance' && data.sum < 100 ? "La suma es menor al 100%: verific\xe1 que las cuotas pertenezcan a la misma l\xednea y mercado." : '';
            } catch (exception) {
                error.textContent = exception.message;
                error.hidden = !showError;
                result.classList.add('result-invalid');
                result.querySelectorAll('[data-value]').forEach((element)=>element.textContent = "\u2014");
                result.querySelector('[data-status]').textContent = "Ingres\xe1 datos v\xe1lidos para calcular.";
            }
        };
        form.addEventListener('submit', (event)=>{
            event.preventDefault();
            run();
        });
        form.addEventListener('input', ()=>run(false));
        form.addEventListener('change', ()=>run());
        form.querySelector('[data-reset]').addEventListener('click', ()=>{
            form.reset();
            run();
        });
        run();
    }
}


//# sourceMappingURL=scripts.af4615fd.js.map
